import isNumber from 'transmute/isNumber';
import FormattedNumber from 'I18n/components/FormattedNumber';
import styled from 'styled-components';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VerticalH6 = styled.h6.withConfig({
  displayName: "CollapsedColumnContent__VerticalH6",
  componentId: "mgs9vg-0"
})(({
  theme
}) => `
  font-size: ${theme['typography']['heading-25']['fontSize']};
  margin: ${theme.space['0']};
  writing-mode: vertical-rl;
  text-orientation: mixed;
  white-space: nowrap;
  max-height: calc(100% - 80px);
  display: flex;
  align-items: center;
  width: 100%;
`);
const EllipsisSpan = styled.span.withConfig({
  displayName: "CollapsedColumnContent__EllipsisSpan",
  componentId: "mgs9vg-1"
})(["overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:inline-block;flex:1;"]);
const CollapsedColumnContent = ({
  columnData
}) => {
  return /*#__PURE__*/_jsxs(VerticalH6, {
    "data-test-id": "cdb-column-collapsed-content",
    children: [/*#__PURE__*/_jsx(EllipsisSpan, {
      children: columnData.name
    }), isNumber(columnData.totalCards) && /*#__PURE__*/_jsx(View, {
      as: "span",
      display: "inline-block",
      marginInlineStart: "300",
      children: /*#__PURE__*/_jsx(FormattedNumber, {
        value: columnData.totalCards
      })
    })]
  });
};
export default CollapsedColumnContent;